import { SetState } from 'zustand';
import '@ui5/webcomponents-react';
import { CommonNonAbapQueryState } from 'stores/interfaces/CommonQueryState';

import ValueState from '@ui5/webcomponents-base/dist/types/ValueState.js';

export const CommonNonAbapQueryInitialStateFields = {
  xtmProjectName: '',
  repository: '',
  collection: '',
  fileName: '',
  stringId: '',
  sourceContact: ''
};

export const CommonNonAbapQueryInitialStateValueStates = {
  xtmProjectNameValueState: ValueState.None,
  repositoryValueState: ValueState.None,
  collectionValueState: ValueState.None,
  fileNameValueState: ValueState.None,
  stringIdValueState: ValueState.None,
  sourceContactValueState: ValueState.None
};

export const CommonNonAbapQueryInitialState = {
  ...CommonNonAbapQueryInitialStateFields,
  ...CommonNonAbapQueryInitialStateValueStates,
  fetching: false
};

export const createCommonNonAbapQuerySlice = <T extends CommonNonAbapQueryState>(
  set: SetState<T>
) => ({
  ...CommonNonAbapQueryInitialState,
  setXtmProjectName: (value: string) => set(() => ({ xtmProjectName: value })),
  setXtmProjectNameValueState: (value: ValueState) =>
    set(() => ({ xtmProjectNameValueState: value })),
  setRepository: (value: string) => set(() => ({ repository: value })),
  setRepositoryValueState: (value: ValueState) => set(() => ({ repositoryValueState: value })),
  setCollection: (value: string) => set(() => ({ collection: value })),
  setCollectionValueState: (value: ValueState) => set(() => ({ collectionValueState: value })),
  setFileName: (value: string) => set(() => ({ fileName: value })),
  setFileNameValueState: (value: ValueState) => set(() => ({ fileNameValueState: value })),
  setStringId: (value: string) => set(() => ({ stringId: value })),
  setStringIdValueState: (value: ValueState) => set(() => ({ stringIdValueState: value })),
  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  setSourceContact: (value: string) => set(() => ({ sourceContact: value })),
  setLanguagesTranslatorTeams: (value?: string) => set(() => ({ languagesTranslatorTeams: value })),
  setSourceContactValueState: (value: ValueState) =>
    set(() => ({ sourceContactValueState: value })),
  resetData: () =>
    set({
      xtmProjectName: '',
      xtmProjectNameValueState: ValueState.None,
      repository: '',
      repositoryValueState: ValueState.None,
      collection: '',
      collectionValueState: ValueState.None,
      fileName: '',
      fileNameValueState: ValueState.None,
      stringId: '',
      stringIdValueState: ValueState.None,
      sourceContact: '',
      sourceContactValueState: ValueState.None
    })
});
